export default "https://cdn-static.gokick.com/assets/ac567471f1b9fb2f6cedfba22f3391469dbaa38e/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";